import axios from '@/libs/axios'

export default {
  namespaced: true,

  state: {
    stockLocation: null,
    stockLocations: [],
  },

  getters: {
    stockLocation(state) {
      return state.stockLocation
    },
    stockLocations(state) {
      return state.stockLocations
    },
  },

  mutations: {
    SET_STOCK_LOCATION(state, value) {
      state.stockLocation = value
    },
    SET_STOCK_LOCATIONS(state, value) {
      state.stockLocations = value
    },
    UPDATE_STOCK_LOCATIONS(state, data) {
      const index = state.stockLocations.findIndex((item) => item.id == data.id)
      if (index >= 0) {
        Object.assign(state.stockLocations[index], data)
      }
    },
    ADD_STOCK_LOCATION(state, data) {
      state.stockLocations.unshift(data)
    },
    DELETE_STOCK_LOCATION(state, id) {
      state.stockLocations.forEach((stockLocation) => {
        if (String(stockLocation.parent_location_id) === String(id)) {
          stockLocation.parent_location_id = null
        }
      })
      const index = state.stockLocations.findIndex((item) => String(item.id) === String(id))
      if (index !== -1) {
        state.stockLocations.splice(index, 1)
      }
    },
  },

  actions: {
    async loadStockLocation({ commit }, stockLocationId) {
      try {
        const response = await axios.get(`api/stockLocations/${stockLocationId}`)
        commit('SET_STOCK_LOCATION', response.data)
        return response.data
      } catch (error) {
        console.error('Error loading stock location:', error)
        throw error
      }
    },
    loadStockLocations({ commit }) {
      return axios.get('api/stockLocations').then((response) => {
        commit('SET_STOCK_LOCATIONS', response.data.data)
      })
    },
    updateStockLocation({ commit }, { formData }) {
      return axios
        .post(`api/stockLocations/${formData.get('id')}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          commit('UPDATE_STOCK_LOCATIONS', response.data.data)
        })
    },
    async searchStockLocation({ commit }, keyword) {
      return await axios
        .post(`api/stockLocations/search`, {
          keyword,
        })
        .then((response) => response.data)
    },
    addStockLocation({ commit }, { formData }) {
      return axios
        .post('api/stockLocations', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          commit('ADD_STOCK_LOCATION', response.data.data)
        })
    },
    makeDefault({ dispatch }, stockLocationId) {
      return axios
        .post(`api/stockLocations/${stockLocationId}/make-default`)
        .then(() => dispatch('loadStockLocations'))
    },
    deleteStockLocation({ commit }, id) {
      return axios.delete(`api/stockLocations/${id}`).then(() => {
        commit('DELETE_STOCK_LOCATION', id)
      })
    },
  },
}
